import { TooltipDirective } from '../../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../../componentes/botones';
import {
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { ILogGenerico, ILogMensaje } from 'modelos/src';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-detalles-log-generico',
  templateUrl: './detalles-log-generico.component.html',
  styleUrl: './detalles-log-generico.component.scss',
  standalone: true,
  imports: [TooltipDirective, BOTONES, MatIconModule],
})
export class DetallesLogGenericoComponent implements OnChanges {
  @Input() title: string;
  @Input() data: ILogGenerico;
  @Output() close = new EventEmitter<void>();

  ngOnChanges(): void {}

  /**
   * Veces que llegó esta misma trama en 30 s: la fila más las copias que
   * irix-alarmas-go contó en `valores.repetido` y no guardó. Vacío cuando
   * llegó una sola vez o cuando el log no es de una alarma (los trackers no
   * lo escriben).
   */
  get veces(): number | undefined {
    const valores = this.data?.valores as
      | (ILogMensaje & { repetido?: number })
      | undefined;
    return valores?.repetido ? valores.repetido + 1 : undefined;
  }

  isObject(val: any): boolean {
    return val && typeof val === 'object' && !Array.isArray(val);
  }

  isString(val: any): boolean {
    return typeof val === 'string';
  }

  isNumber(val: any): boolean {
    return typeof val === 'number';
  }

  onClose(): void {
    this.close.emit();
  }
}
